module.exports = __webpack_public_path__ + "img/MUSA-22.059fbdbe.jpg";